class MediaSlider extends HTMLElement {
  constructor() {
    super();
    this._track = null;
    this._prev = null;
    this._next = null;
  }

  connectedCallback() {
    this._track = this.querySelector("[data-slider-track]");
    if (!this._track) return;
    this._prev = this.querySelector("[data-slider-prev]");
    this._next = this.querySelector("[data-slider-next]");

    this._track.classList.add("media-slider-track");
    this.classList.add("media-slider");
    this.tabIndex = 0;

    this._prev?.addEventListener("click", () => this.scrollBySlide(-1));
    this._next?.addEventListener("click", () => this.scrollBySlide(1));
    this.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        this.scrollBySlide(-1);
      }
      if (event.key === "ArrowRight") {
        event.preventDefault();
        this.scrollBySlide(1);
      }
    });
    this.updateButtons();
    this._track.addEventListener("scroll", () => this.updateButtons(), { passive: true });
    window.addEventListener("resize", () => this.updateButtons());
  }

  scrollBySlide(direction) {
    if (!this._track) return;
    const slide = this._track.querySelector(":scope > *");
    if (!slide) return;
    const gap =
      parseFloat(window.getComputedStyle(this._track).columnGap || window.getComputedStyle(this._track).gap) || 0;
    const step = slide.getBoundingClientRect().width + gap;
    this._track.scrollBy({ left: direction * step, behavior: "smooth" });
  }

  updateButtons() {
    if (!this._track) return;
    const maxScroll = this._track.scrollWidth - this._track.clientWidth;
    const atStart = this._track.scrollLeft <= 1;
    const atEnd = this._track.scrollLeft >= maxScroll - 1;
    if (this._prev) this._prev.disabled = atStart;
    if (this._next) this._next.disabled = atEnd;
  }

  disconnectedCallback() {
    window.removeEventListener("resize", () => this.updateButtons());
  }
}

if (!customElements.get("media-slider")) {
  customElements.define("media-slider", MediaSlider);
}
